import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(() => import("../components/certificate/main"));

const Certificate = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default Certificate;